import { render, staticRenderFns } from "./statusInfo.vue?vue&type=template&id=79b1f508&scoped=true"
import script from "./statusInfo.vue?vue&type=script&lang=js"
export * from "./statusInfo.vue?vue&type=script&lang=js"
import style0 from "./statusInfo.vue?vue&type=style&index=0&id=79b1f508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b1f508",
  null
  
)

export default component.exports